// Calendly Configuration
// Centralized configuration for Calendly integration
// Updated: Two meeting types - intro (30min) and personalised demo (45min)

export const CALENDLY_CONFIG = {
  // Intro meeting - first call with all prospects
  intro: {
    eventUrl: import.meta.env.VITE_CALENDLY_INTRO_URL || 'https://calendly.com/ROBERT_CALENDLY_SLUG/30min',
    utmSource: 'fleetvision-intro',
    utmMedium: 'onboarding',
    label: 'FleetVision Intro Call'
  },
  
  // Personalised demo - after API connected, walk through their data
  demo: {
    eventUrl: import.meta.env.VITE_CALENDLY_DEMO_URL || 'https://calendly.com/ROBERT_CALENDLY_SLUG/new-meeting',
    utmSource: 'fleetvision-app',
    utmMedium: 'onboarding',
    label: 'FleetVision Personalised Walkthrough'
  },
  
  // Widget styling (shared)
  styles: {
    height: '700px'
  }
}

// Helper to get UTM campaign parameter (uses Firebase UID)
export const getUtmCampaign = (userId) => {
  return userId || 'unknown'
}

// Helper to get config by meeting type
export const getCalendlyConfig = (type) => {
  return CALENDLY_CONFIG[type] || CALENDLY_CONFIG.intro
}
